import React from 'react'
import { DataBox } from './DataBox'
import { PageHeader } from './PageHeader'
import { useLedgerModel } from '../ledgerModel'
import { EditLedgerModal } from './editLedgerModal'

export function ThreeInspectionLedger() {
    const { editCarVisible } = useLedgerModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {editCarVisible.visible && <EditLedgerModal />}
        </>
    )
}
